var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-ee",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 477.9,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 159.3,
    y: 320.7,
    fill: "#fff",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1791ff",
    d: "M0 0h640v159.3H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEe);
export default __webpack_public_path__ + "static/media/ee.bd3f873d66e924740c134ff9940e988f.svg";
export { ForwardRef as ReactComponent };